/** BCP 47 tags for hreflang (matches each tools locale route). */
export const LANG_TO_HREFLANG = {
  en: "en-us",
  fr: "fr",
  de: "de",
  es: "es",
  pl: "pl",
  kr: "ko",
  jp: "ja",
  sv: "sv",
  no: "nb",
  tr: "tr",
  tw: "zh-Hant",
  cn: "zh-Hans",
  ro: "ro",
  nl: "nl",
  ru: "ru",
  it: "it",
  he: "he",
  bg: "bg",
  hr: "hr",
  cs: "cs",
  da: "da",
  et: "et",
  fi: "fi",
  el: "el",
  hu: "hu",
  ga: "ga",
  lv: "lv",
  lt:"lt",
  mt: "mt",
  pt: "pt",
  sk: "sk",
  sl: "sl",
  ar: "ar",
  bs: "bs",
  my: "my",
  ca: "ca",
  id: "id",
  sr: "sr",
  th: "th",
  uk: "uk",
  vi: "vi"
};

export const LANG_TO_HTML_LANG = {
  en: "en-US",
  fr: "fr",
  de: "de",
  es: "es",
  pl: "pl",
  kr: "ko",
  jp: "ja",
  sv: "sv",
  no: "nb",
  tr: "tr",
  tw: "zh-Hant",
  cn: "zh-Hans",
  ro: "ro",
  nl: "nl",
  ru: "ru",
  it: "it",
  he: "he",
  bg: "bg",
  hr: "hr",
  cs: "cs",
  da: "da",
  et: "et",
  fi: "fi",
  el: "el",
  hu: "hu",
  ga: "ga",
  lv: "lv",
  lt:"lt",
  mt: "mt",
  pt: "pt",
  sk: "sk",
  sl: "sl",
  ar: "ar",
  bs: "bs",
  my: "my",
  ca: "ca",
  id: "id",
  sr: "sr",
  th: "th",
  uk: "uk",
  vi: "vi"
};
